import {
  CONFIRM_FILES_UPLOAD_TEST_ID,
  FILE_MANAGER_DROPZONE_TEST_ID,
  FILE_PREVIEW_ROOT_TEST_ID,
} from './automation-test-ids';

export const TestIds = {
  ActionItemsNumber: 'action-items-number',
  ActionItemTitle: 'action-item-title',
  ActionItemDescription: 'action-item-description',
  ActionItemAssignee: 'action-item-assignee',
  ActionItemDeadline: 'action-item-deadline',
  /** Use as `` `${TestIds.ActionItemActionPrefix}${type}` `` with `ActionItemType`. */
  ActionItemActionPrefix: 'action-item-action-',
  /** Use as `` `${TestIds.StageTabPrefix}${id}` `` with project tab id. */
  StageTabPrefix: 'stage-',
  ClosedEyeIcon: 'closed-eye-icon',
  OpenEyeIcon: 'open-eye-icon',
  FileUploadButton: 'file-upload-button',
  /**
   * Visible FileManager drop zone (dashed border). The real `<input type="file">`
   * is inside but hidden by react-dropzone; in tests use:
   * `getByTestId(...).locator('input[type="file"]').setInputFiles(...)`.
   */
  FileManagerDropzone: FILE_MANAGER_DROPZONE_TEST_ID,
  ConfirmFilesUploadButton: CONFIRM_FILES_UPLOAD_TEST_ID,
  FilePreview: FILE_PREVIEW_ROOT_TEST_ID,
  DocumentTagSelector: 'document-tag-selector',
  DocumentTypeCombobox: 'document-type-combobox',
  SpendCategoryCombobox: 'spend-category-combobox',
  VendorCombobox: 'vendor-combobox',
  VendorsCategorySelect: 'vendors-category-select',
  VendorPointOfContactPopover: 'vendor-poc-popover',
  VendorPointOfContactPhone: 'vendor-poc-phone',
  VendorPointOfContactEmail: 'vendor-poc-email',
  DocumentFilenameEditor: 'document-filename-editor',
  AddTagButton: 'add-tag-button',
} as const;

export type TestId = (typeof TestIds)[keyof typeof TestIds];
